<template>
  <div class="app-custom">
    <el-carousel class="custom-carousel" :interval="5000" height="20vw">
      <el-carousel-item class="custom-carousel">
        <el-image style="width: 100%;height: 100%;" :src="require('@/assets/case.jpg')" alt="轮播图1" />
      </el-carousel-item>
    </el-carousel>

    <el-tabs class="custom-tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in categories"
        :key="item.id"
        :label="item.title"
        :name="String(item.id)"
      />
    </el-tabs>

    <el-row class="custom-describe" type="flex" justify="justify-start" flex-wrap>
      <el-col :span="6" v-for="(item, index) in caseLists" :key="index" class="card-col">
        <el-card class="describe-card" :body-style="{ padding: '1vw' }"  shadow="hover">
          <div class="card-header" slot="header" @click="goDetail(item.classify_id, item.id)">
            <div class="header-box">
              <el-image class="box-image" :src="item.image" alt="宣传图"/>
            </div>

            <el-row class="header-title" type="flex">
              <h3 class="card-title">{{ item.title }}</h3>
            </el-row>
          </div>
          <p class="card-body" @click="goDetail(item.classify_id, item.id)">
            <span v-html="$formatContent(item.content)"></span>
            <span v-if="item.content && item.content.length > 30"
                  class="show-more"
                  @click.stop="goDetail(item.classify_id, item.id)">
              ...查看更多
            </span>
          </p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { articleClass, articleList } from '@/api/index'
export default {
  data(){
    return {
      activeName: '',
      categories: [], // 分类
      // 案例列表
      caseLists: []
    }
  },
  created(){
    this.classify_id = this.$route.query.classify_id || null;
    // this.activeName = this.$route.query.id || null;
    this.$store.dispatch('getHomeData').then(() => {
      this.getArticle()
    });
  },
  methods:{
    handleClick(tab) {
      this.getArticleList(tab.name);
    },
    // 文章分类
    async getArticle() {
      await articleClass({classify_id: this.classify_id}).then(res => {
        if (res.data.rows && res.data.rows.length > 0) {
          // 过滤掉 status 为 0 的数据
          this.categories = res.data.rows.filter(item => item.status !== 0);
          if (this.categories.length > 0) {
            this.activeName = String(this.categories[0].id);
            this.getArticleList(this.activeName);
          }
        }
      })
    },
    // 文章列表
    getArticleList(id) {
      articleList({
        classify_id: id
      }).then(res => {
        if (res.data.rows) {
          // 过滤掉 status 为 0 的数据
          this.caseLists = res.data.rows.filter(item => item.status !== 0);
        } else {
          this.caseLists = [];
        }
      })
    },
    // 详情
    goDetail(classify_id, id) {
      // 将来源路径存储在 sessionStorage 中
      sessionStorage.setItem('fromPath', this.$router.history.current.fullPath);
      this.$router.replace({
        path: '/newsDetail',
        replace: true,
        query: { classify_id: classify_id, id: id }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.app-custom{
  .custom-carousel{
    min-height: 340px;
  }
  .custom-tabs{
    width: 85%;
    margin: 2vw auto 1vw auto;
  }
  .custom-describe{
    width: 80%;
    min-height: 395px;
    margin: 0 auto 5vw auto;
    .card-col {
      padding: 10px;
      box-sizing: border-box;
    }
    .describe-card{
      height: 100%;
      .el-card__header{
        padding: 0 0;
      }
      .card-header{
        .header-box{
          height: 10.5vw;
          min-height: 100px;
          overflow: hidden;
          .box-image{
            width: 100%;
            height: 100%;
            transition: all 0.3s linear;
          }
          .box-image:hover{
            transform: scale(1.1);
          }
        }
        .header-title{
          align-items: center;
          padding-left: 20px;
        }
      }
      .card-body {
        font-size: 14px;
        text-indent: 2em;

        .show-more {
          color: #409EFF;
          cursor: pointer;
          margin-left: 5px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>
